import script from "./TaskDetailRightSide.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskDetailRightSide.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=436fb03f&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-436fb03f"]])

export default __exports__